module.exports = __webpack_public_path__ + "static/media/shmp.8ee38fc0.png";